import { Pagination } from 'components/shared/Blotter/Pagination/Pagination';

import { connectSecondaryMarketOrderBlotterPagination } from './Pagination.connect';

export const SecondaryMarketOrderBlotterPagination = connectSecondaryMarketOrderBlotterPagination(Pagination);
